import { z } from "zod";
import {
  DocumentMetaTs,
  ImageTs,
  LocaleTs,
} from "../../common";

import { OmitDocumentMeta } from "@/providers/strapi/client/types";
import { SingleTypes } from "..";

import { CoFounderCardSchema, CommitmentCardSchema, JoinUsCardSchema, MissionCardSchema, WhatDriveUsSchema } from "../components/about-us.component";
import { useContext } from "react";
import { ContentContext } from "../../content-provider";




export type AboutUsPage = z.output<typeof AboutUsPageTs>;

export const AboutUsPageTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  localizations: z.array(DocumentMetaTs),
  title: z.string(),
  content: z.string(),
  images: ImageTs.extend({
    id: z.int(), // <int>
    documentId: z.string(),
    formats: z.object({
      large: ImageTs.optional(), // 1000px
      medium: ImageTs.optional(), // 750px
      small: ImageTs.optional(), // 500px
      thumbnail: ImageTs.optional(), // 250px
    }).optional(),
  }).array().min(2).max(2),
  coFounderCard: CoFounderCardSchema,
  missionCard: MissionCardSchema,
  whatDriveUsCard: WhatDriveUsSchema,
  joinUsCard: JoinUsCardSchema,
  commitmentsCard: CommitmentCardSchema
})

export const ABOUT_US = 'about-us';
export function useAboutUsPage<
  K extends keyof Omit<AboutUsPage, "id" | "locale" | "localizations" | OmitDocumentMeta>
>(
  entity: K,
  // contextKey: string
): AboutUsPage[K] {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`${entity} content not found`)
  const singletype = content[ABOUT_US] as AboutUsPage;
  if (!singletype || !singletype[entity]) throw new Error(`${entity} content not found`)
  return singletype[entity]
}

